import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isIterableArray } from '../../helpers/utils';

/*
What a past export was drawn from: the words typed into the search box and the
filters that were switched on, as the admin saw them at the time.
*/
const RandomSetFilters = ({ filters, keywords }) => {
  const groups = isIterableArray(filters) ? filters.filter(group => isIterableArray(group.values)) : [];

  if (!keywords && !isIterableArray(groups)) {
    return <span className="text-600">All content</span>;
  }

  return (
    <Fragment>
      {keywords && (
        <Badge color="soft-info" className="rounded-capsule fs--1 mr-1 text-wrap text-left">
          <FontAwesomeIcon icon="search" transform="shrink-3" className="mr-1" />
          {keywords}
        </Badge>
      )}
      {groups.map(group => (
        <Badge key={group.label} color="soft-secondary" className="rounded-capsule fs--1 mr-1 text-wrap text-left">
          {group.label}: {group.values.join(', ')}
        </Badge>
      ))}
    </Fragment>
  );
};

RandomSetFilters.propTypes = {
  filters: PropTypes.array,
  keywords: PropTypes.string
};

RandomSetFilters.defaultProps = {
  filters: [],
  keywords: ''
};

export default RandomSetFilters;
